/// <reference path="../../../../app.definition.ts" />

import { JavaApiAdapterService } from "@/app/common/apiadapter/javaapi.service";
import { CommonService } from "@/app/common/common.service";
import { PostTypeEnums } from "@/app/common/model/_adocument";
import { FOLDER_MODULES } from "@/app/common/model/constants";
import { Discussion } from "@/app/common/model/discussion";
import { Subject } from "@/app/common/model/subject";
import { User } from "@/app/common/model/user";
import { ViewPortData } from "@/app/common/model/ViewPortData";
import { PopUpService } from "@/app/common/popup/popup.service";
import { CacheService } from "@/app/common/service/cache.service";
import { ICachingService } from "@/app/common/service/caching.service";
import { IConfigService } from "@/app/common/service/config.service";
import { IFeedService } from "@/app/common/service/feed.service";
import { INudgeService } from "@/app/common/service/nudge.service";
import { IPostService } from "@/app/common/service/post.service";
import { ISubjectService } from "@/app/common/service/subject.service";
import { TeamVaultService } from "@/app/common/service/teamvault.service";
import { IUserService } from "@/app/common/service/user.service";
import { IDocumentService } from "@common/service/document.service";
import { TargetEnum, PermissionsEnum, PermissionService } from "ecv/common/permissions";
import { EcvPost } from '@common/itemCard/components/post/post.directive';
import angular from "angular";
import _ from "lodash";
import { IAppRootScopeService } from "@/app/app.definition";
import { PaymentService } from "@/app/common/service/payment.service";
import { IBroadcastService } from "@/app/common/service/broadcast.service";
import { AppService } from "@/app/app.service";

interface IEcvPostBoard {
    newPostSubjectChoice(subject?: Subject): void;
    addPhoto($file, $err): void;
    cancelPhoto(): void;
    cancelDocument(): void;
    sendComment(post: Discussion, callback: Function): void;
    displayPost(post: Discussion): boolean;
    registerNoteSentCallback(key: string, callback: Function): void;
    init(order?: string, size?: number, withDiscussion?: boolean, withCommentsOnly?: boolean): void;
    saveState(): void;
    restoreState(): void;
    clearState(): void;
    newPostsNotification(type: string, data?: any): void;
    postUploaded(id: number): void;
    postFailed(id: number): void;
    updateDocumentMetadata(id: number, data: any, updateMetadata: boolean): void;
    reloadPosts();
    updatePostSubject(id: number, action: string);
    resetFeeds: boolean;
    deleteDoc(): void;
    subject: Subject;
}

class EcvPostBoard implements IEcvPostBoard {
    initialized: boolean;
    userId: number;
    user: User;
    subjectId: number;
    subject: Subject;
    allPosts: Array<Discussion>;
    filteredPosts = [];
    firstTimeLoad = true
    activePostsCnt = 0;
    boardType: string;
    boardName: string;
    expandOnClick: boolean;
    displayAs: string;
    incId: string;
    nothingNew: boolean;
    withDiscussion: boolean;
    withCommentsOnly: boolean;
    statusUploading: string;
    status: string;
    recentPostId: number;
    documentUpload: Document;
    refreshViewCallback: Function;
    showComments: boolean;
    uploadType: string;
    postVms: Array<EcvPost>;
    loadTimeout: any;
    defaultLimit: number;
    submittedOnce: boolean = false;
    noteSentCallbacks: {} = {};
    isValidStatus: boolean = true;
    loadMore: boolean = false;
    moreFeedsAvailable: boolean = true;
    pendingRequest: boolean = false;
    displayNewPostButton: boolean;
    onLoadCallback: Function;
    loaded: boolean = false;
    singleton: boolean;
    isCarefeedInIE: boolean;
    photoUpload: {
        content: string,
        name: string
    };
    boardData;
    justLoggedIn;
    totalDoc;
    resetFeeds = false;

    conf: {
        order: string,
        limit: number,
        limitIncrement: number
    }
    documentList: Array<any>;
    buildUpldPerm = false;
    loading: boolean = false;
    itemTopIndex: number;

    static $inject = ['$timeout', 'TeamVaultService', 'UserService', 'SubjectService',
        'ConfigService', 'ApiAdapterService', 'PopUpService', 'CommonService', 'PostService',
        'CacheService', 'CachingService', 'FeedService', '$state', '$rootScope', '$scope', '$q',
        'PaymentService', 'NudgeService', 'DocumentService', 'BroadcastService', 'AppService', 'PermissionService'];
    constructor(
        private $timeout: ng.ITimeoutService,
        private $_tvault: TeamVaultService,
        private $_user: IUserService,
        private $_subject: ISubjectService,
        private $_config: IConfigService,
        private $_api: JavaApiAdapterService,
        private $_pop: PopUpService,
        private $_com: CommonService,
        private $_post: IPostService,
        private $_cache: CacheService,
        private $_caching: ICachingService,
        private $_feed: IFeedService,
        private $state: ng.ui.IStateService,
        private $rootScope: IAppRootScopeService,
        private $scope: ng.IScope,
        private $q: ng.IQService,
        private PaymentService: PaymentService,
        private $_nudge: INudgeService,
        private $_document: IDocumentService,
        private BroadcastService: IBroadcastService,
        private AppService: AppService,
        private PermissionService: PermissionService
    ) {
        const passwordModal = angular.element('body').find('.password-modal');
        if (!!passwordModal && passwordModal.length == 0) {
            this.$rootScope.mainShowLoader = true;
        }

        this.$scope.$on('$destroy', () => {
            this.saveState();
            this.BroadcastService.removeCallBack('user-logged-in', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('new-document', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('document-updates', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('post-updates', this.$scope.$id);
            this.BroadcastService.removeCallBack('post-and-feeds-updates', this.$scope.$id);
            this.BroadcastService.removeCallBack('discussion-updates', this.$scope.$id);
            this.BroadcastService.removeCallBack('reload-feeds', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('document-uploaded', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('document-failed', this.$rootScope.$id);
            this.BroadcastService.removeCallBack('update-document-metadata', this.$scope.$id);
            this.BroadcastService.removeCallBack('team-updates', this.$scope.$id);
            this.BroadcastService.removeCallBack('doc-user-updates', this.$scope.$id);
            this.BroadcastService.removeCallBack('new-info-floater', this.$scope.$id);
            this.BroadcastService.removeCallBack('document-del-updates', this.$scope.$id);

            //On page change remove the failed entries from cached feeds
            this.$_feed.removeFailedDocsFeeds();
            this.$_caching.removeFailedDocs();

            (this.resetFeeds) && this.resetCachedFeeds();
        });
    }

    sendComment = (post: Discussion, callback?: Function): void => {
        const ap = angular.copy(this.allPosts);
        this.$_post.addComment(post,
            (s, copyComment) => {
                this.recentPostId = post.id;
                copyComment.id = s.id;
                copyComment.commentTime = s.commentTime;
                copyComment.sender = s.sender;
                post.comments.push(s);
                post.currentComment = '';
                post.lastActionTime = s.commentTime;
                s.sender = new User().deserialize(this.$_user.getMe());
                const comment = s;

                post.commentsCount += 1;
                this.$_feed.addNewFeed(post, "discussions").then((s) => {
                    const filteredPost = ap.filter((p) => {
                        return p.id == post.id;
                    });
                    if (!!filteredPost && filteredPost.length > 0) {
                        filteredPost[0].comments.push(comment);
                        filteredPost[0].commentsCount = filteredPost[0].comments.length;
                        ap[ap.indexOf(filteredPost[0])] = filteredPost[0];
                        this.allPosts = ap;
                    }
                }, (e) => {
                    console.log(e);
                });

                //If first comment, note was turned into a discussion, trigger callback
                if (!!this.refreshViewCallback && post.comments.length == 1) {
                    this.refreshViewCallback('discussion');
                }
                // console.log("DiscussionType: " + post.documentType);

                // Check each of the registered postVms to see if updating is needed.
                angular.forEach(this.postVms, (vm) => {
                    if (vm.post.id == post.id) {
                        vm.loadMoreComments((comments) => {
                            post.commentsCount = post.comments.length
                            console.log("Loaded more comments for post:", vm.post.id);
                            if (!!callback) {
                                callback();
                            }

                        });
                    } else {
                        if (!!callback) {
                            callback();
                        }
                    }
                });
                if (!!callback) {
                    callback();
                }
                this.$rootScope.mainShowLoader = false;
                // if ('FOLIO,DOCUMENT'.indexOf(post.documentType) > -1 && post.comments.length == 1) {
                //     that.init('discussion');
                // }
            },
            (e, copyComment) => {
                this.$rootScope.mainShowLoader = false;
                console.error('EcvPostBoard: Failed to send comment: ', e);
                this.recentPostId = post.id;
                copyComment.id = 999999;
            }
        )
    }

    newPostsNotification = (type: string, data?: any): void => {
        if (this.boardType == type) {
            if (this.singleton) {
                if (!!data && this.allPosts[0].id == data) {
                    this.displayNewPostButton = true;
                }
            } else {
                this.displayNewPostButton = true;
            }
        }
    }

    //New info floater click
    loadNewPosts = (): void => {
        this.displayNewPostButton = false;
        if (!this.singleton) {
            (this.resetFeeds) && this.resetCachedFeeds();
            this.refreshViewPort(0, false);
        } else {
            this.$state.reload();
        }
    }

    deleteDoc = () => {
        this.refreshViewPort(0, true);
        //if doc/disc is deleted from single view page then redirect to respective list page
        if (!!this.singleton) {
            this.$state.go('documents-load', { action: 'parent-team-vault' });
        }
    }

    resetCachedFeeds = () => {
        this.resetFeeds = false;
        this.$_caching.resetCachedFeeds();
    }

    updateLocalFeeds(newfeeds: any, localFeeds: any, type: string): void {
        if (!!localFeeds) {
            localFeeds[type] = newfeeds;
        } else {
            localFeeds = {
                posts: [],
                documents: [],
                discussions: []
            };
            localFeeds[type] = newfeeds;
        }
        //this.$_cache.setLocalFeeds(localFeeds);
    }

    displayPost(post: Discussion): boolean {
        let disp = false;
        switch (this.displayAs) {
            case 'discussion':
                disp = post.contentType == 'discussion' || EcvPost.hasComments(post);
                break;
            case 'document':
                disp = post.postType == PostTypeEnums.LINK || EcvPost.hasFile(post) || (EcvPost.hasImage(post) && (!post.attachments || post.attachments.length == 0));
                break;
            default:
                disp = true;
        }

        return disp && !!post && !post.isDeleted;
    }

    newPostSubjectChoice(subject?: Subject): void {
        !!subject || (subject = this.subject);
        this.subject = subject;
    }

    registerNoteSentCallback = (key: string, callback: Function): void => {
        if (!this.noteSentCallbacks[key]) {
            //console.log('EcvPostBoard: Registering NoteSentCallback: ', key);
            this.noteSentCallbacks[key] = callback;
        }
    }

    cancelPhoto(): void {
        this.photoUpload = null;
    }

    cancelDocument(): void {
        this.documentUpload = null;
    }

    addPhoto($file, $err): void {

        if (!$file || $err) {
            // console.log('addPhoto returning', $file, $err);
            return;
        }

        if (!this.$_tvault.checkFile($file)) {
            this.$_pop.openInformationModal('File has a size greater than 7MB.');
            return;
        }

        const reader = new FileReader(); // Reading in Base64
        const that = this;
        reader.onload = function (e) {
            let content = !e ? reader['content'] : e.target['result'];
            content = window.btoa(content);

            that.photoUpload = {
                'content': 'data:' + $file.type + ';base64,' + content,
                'name': $file.name
            }
            if (that.photoUpload) {
                that.isValidStatus = true;
            } else {
                that.isValidStatus = false;
            }
            that.documentUpload = null;
        };

        const blob = $file.slice();
        reader['readAsBinaryString'](blob);
        return;
    }

    addPostCallback = (postVm: EcvPost, action?: string): boolean => {
        if (!!postVm && action != 'DELETE') {
            this.postVms = [postVm].concat(this.postVms);
        } else if (!!postVm && action == 'DELETE') {
            postVm.post.isDeleted = true;
            this.refreshViewPort(0, true);
            //if doc/disc is deleted from single view page then redirect to respective list page
            if (!!this.singleton) {
                if (postVm.post.postType == FOLDER_MODULES.DISCUSSION) {
                    this.$state.go('discussions-load',{action:'discussion-board',stateParams:{}});
                } else if (_.includes(["DOCUMENT", "LINK"], postVm.post.postType)) {
                    // Redirect to RL page if document deleted from RL module in view document page
                    if (this.$state.current.name === 'view-rl-document') {
                        this.$state.go('documents-load', { action: 'list-rl' });
                    } else {
                        this.$state.go('documents-load', { action: 'parent-team-vault' });
                    }
                }
            }

        }
        return true;
    }

    refreshPosts(): void {
        angular.forEach(this.postVms, (postVm) => postVm.init());
    }

    subjectChangeCallback = (subject: Subject) => {
        this.subject = subject;
    }

    init(order?: string, limit?: number, withDiscussion?: boolean, withCommentsOnly?: boolean): void {
        this.conf = this.$_config.get('postBoard');
        this.isCarefeedInIE = (isIE11 && this.boardName == "CareFeed");
        this.loadMore = false;
        // restore the saved state if any
        this.restoreState();
        // get notified when subject changes, can call repeatedly, will only register once.
        this.$_subject.registerSubjectChangeCallback(this.boardName, this.subjectChangeCallback);
        this.postVms = [];
        this.initialized = false;
        !!this.user || (this.user = this.$_user.getMe());
        this.subject = this.$_subject.getCurrentSubject();
        this.nothingNew = false;
        this.allPosts = [];
        !!this.showComments || (this.showComments = false);
        !!order && (this.conf.order = order);
        !!this.defaultLimit && (this.conf.limit = this.defaultLimit) || !!limit && (this.conf.limit = limit);
        (!!withDiscussion && (this.withDiscussion = withDiscussion)) || (this.withDiscussion = false);

        this.expandOnClick = this.displayAs != 'note' && !this.singleton; //If not a note, card expands when clicked

        if (!!this.subject) {
            this.newPostSubjectChoice(this.subject);
            this.PermissionService.fetchPermissionsForTarget([this.subject.teamPartyId]).then((data) => {
                this.buildUpldPerm = data[this.subject.teamPartyId][TargetEnum.TEAMMEMBER][PermissionsEnum.CREATE] || data[this.subject.teamPartyId][TargetEnum.DOCUMENT][PermissionsEnum.CREATE];
            }).catch(e => {
                console.error(e)
            })
        }

        if (!this.initialized) {
            this.initialized = true;
        }

        this.displayNewPostButton = false;
        if (!(this.singleton && this.displayAs == 'discussion')) {
            //for single discussion the screen is loading from a loadComments method
            if (Array.isArray(this.documentList) && this.documentList.length > 0) {
                this.allPosts = this.documentList;
            }
            this.refreshViewPort(0, false);
        }

        this.BroadcastService.registerCallBack('user-logged-in', this.$rootScope.$id, (data) => {
            this.$rootScope.mainShowLoader = true;
            this.justLoggedIn = true;
            this.newPost(data);
        });
        this.BroadcastService.registerCallBack('new-document', this.$rootScope.$id, (data) => {
            this.newPost(data);
        });
        this.BroadcastService.registerCallBack('document-updates', this.$rootScope.$id, (data) => {
            this.newPostsNotification("documents", data);
        });

        this.BroadcastService.registerCallBack('post-updates', this.$scope.$id, () => {
            this.newPostsNotification("posts");
        });

        this.BroadcastService.registerCallBack('post-and-feeds-updates', this.$scope.$id, (data) => {
            if (!this.singleton) {
                this.resetFeeds = true;
                (!!data) && this.newPostsNotification("posts");
            }
        });

        this.BroadcastService.registerCallBack('discussion-updates', this.$scope.$id, (data) => {
            this.newPostsNotification("discussions", data);
        });

        this.BroadcastService.registerCallBack('reload-feeds', this.$rootScope.$id, (data) => {
            this.reloadPosts();
        });

        this.BroadcastService.registerCallBack('comments-loaded', this.$rootScope.$id, (data) => {
            this.loadComments();
        });

        this.BroadcastService.registerCallBack('document-uploaded', this.$rootScope.$id, (data) => {
            this.postUploaded(data);
        });

        this.BroadcastService.registerCallBack('document-failed', this.$rootScope.$id, (data) => {
            this.postFailed(data);
        });

        this.BroadcastService.registerCallBack('update-document-metadata', this.$scope.$id, (id, data, updateMetadata) => {
            this.updateDocumentMetadata(id, data, updateMetadata);
        });

        this.BroadcastService.registerCallBack('team-updates', this.$scope.$id, (id, action) => {
            this.updatePostSubject(id, action);
        });

        this.BroadcastService.registerCallBack('doc-user-updates', this.$scope.$id, (subjectId, user) => {
            this.updatePostUsers(subjectId, user);
        });

        this.BroadcastService.registerCallBack('new-info-floater', this.$scope.$id, () => {
            this.loadNewPosts();
        });

        this.BroadcastService.registerCallBack('document-del-updates', this.$scope.$id, (docId) => {
            this.deleteDoc();
        });
    }

    restoreState(): void {
        const postBoardState = this.$_cache.getPostBoardState();
        this.$_cache.setPreviousSubject(null);
        if (!!postBoardState) {
            this.status = postBoardState.status;
            this.documentUpload = postBoardState.documentUpload;
            this.photoUpload = postBoardState.photoUpload;
            if (!!this.$_cache.getCurrentSubject()) {
                this.subject = this.$_cache.getCurrentSubject();
            } else {
                this.subject = postBoardState.subject;
            }
        }
    }

    saveState(): void {
        let sub = null;
        const previousSubject = this.$_cache.getPreviousSubject();
        if (!!this.subject && !!previousSubject && (this.subject.subjectId == previousSubject.subjectId)) {
            sub = null;
        } else {
            sub = this.subject;
        }
        this.$_cache.setPostBoardState({
            status: this.status,
            documentUpload: this.documentUpload,
            photoUpload: this.photoUpload,
            subject: sub
        });
    }

    clearState(): void {
        this.status = null;
        this.documentUpload = null;
        this.photoUpload = null;
        this.subject = null;
        this.$_cache.setPostBoardState(null);
    }

    sendOnloadCallback(): void {
        this.loaded = true;
        this.$rootScope.mainShowLoader = false;
        //On login the CF page is loaded after vault key screen, so show the team inv alert
        // and other popups after the CF page finishes loading.
        if (!!this.justLoggedIn) {
            this.justLoggedIn = false;
            this.AppService.showPostLoginPopups();
        }
        const type = this.boardType.substring(0, this.boardType.length - 1);
        if (!!this.allPosts && this.allPosts.length <= 0 && type != "post") {
            this.PaymentService.checkLimitAndProceed(type, null, this.subject.isFormerTeamMember || this.subject.isFrozen).then((s) => {
                //do nothing
            }, (e) => {
                if (!!e) {
                    //do nothing
                } else {
                    window.history.back();
                }
            })
        }
        !!this.$_nudge.activeTour && this.$_nudge.refreshOverlay();
        if (!!this.onLoadCallback) {
            this.onLoadCallback(!!this.allPosts ? this.allPosts.length : 0);
        }
    }

    fetchActivePosts = (start = 0, end = 10) => {
        const deferred = this.$q.defer();
        const type = this.boardType;
        let filter = { documentTypes: ["DISCUSSION"], addComments: this.showComments };
        if (type === 'posts') {
            filter.documentTypes.push("DOCUMENT")
        }

        if (this.subject) {
            filter['subjectId'] = this.subject.subjectId;
        }

        let pgSz = end - start;
        let pg = Math.ceil(start / pgSz);
        this.$_feed.getPaginatedDocFeeds(type, pg, pgSz, filter, null).then((data) => {
            this.firstTimeLoad = false;
            this.filteredPosts = this.filteredPosts.concat(data.posts);
            this.activePostsCnt = data['totalElements'];
            deferred.resolve(data.posts);
        });
        return deferred.promise;
    }

    loadFeeds = (pageNumber: number) => {
        const deferred = this.$q.defer();
        const obj = this.boardData.getPageStartEndIndexes(pageNumber);

        let cachedSub = this.$_feed.getCachedFeedIds(this.boardType);
        if (cachedSub.length >= obj.endIndex) {
            const posts = cachedSub.slice(obj.startIndex, obj.endIndex);
            this.$_caching.getDiscussionObjects(posts).then(res => {
                deferred.resolve(res);
            });
        } else {
            this.fetchActivePosts(obj.startIndex, obj.endIndex).then(posts => {
                deferred.resolve(posts);
            });
        }
        return deferred.promise;
    }

    initVPLoadingV2 = (numItems) => {
        const pageLoading = {};
        if (this.singleton) {
            this.boardData = new ViewPortData({}, 0, 10, 1);
        } else {
            this.totalDoc = this.activePostsCnt;
            this.boardData = new ViewPortData({}, numItems, 10, this.totalDoc);
        }
        this.allPosts.splice(0, this.allPosts.length);
        this.boardData.fetchPage = (pageNumber) => {
            const deferred = this.$q.defer();
            if (pageNumber > 0 && (!this.boardData.loadedPages[pageNumber - 1] || !!pageLoading[pageNumber])) {
                //if previous page is not loaded yet then wait for that
                return;
            }
            pageLoading[pageNumber] = true;
            // Set the page to null so we know it is already being fetched.
            this.boardData.loadedPages[pageNumber] = null;
            if (pageNumber > 1) {
                this.loading = true;
            }
            this.loadFeeds(pageNumber).then((docs) => {
                const newPosts = angular.copy(docs) as Discussion[];
                this.allPosts = this.allPosts.concat(newPosts);
                this.boardData.loadedPages[pageNumber] = newPosts.map(d => [d]);
                //Many times(when user accepts invitation through email) the view port
                // gets created before the document cache is updated, because of which
                // the carefeed gets empty.
                if (this.totalDoc < this.allPosts.length) {
                    this.boardData.refreshViewPortData(this.boardData.loadedPages, this.boardData.numItems, this.totalDoc);
                }

                this.$timeout(() => {
                    this.loading = false;
                    this.boardData.numItems += newPosts.length;
                    this.sendOnloadCallback();
                    deferred.resolve();
                }, 100);
            });
            return deferred.promise;
        };
    }


    fixCachedDoc = () => {
        if (this.boardType === 'posts') {
            let cachedFeed = this.$_caching.getCachedFeeds();
            const currentCachedFeed = cachedFeed[this.boardType];
            const fixedLen = currentCachedFeed.length - (currentCachedFeed.length % 10);
            cachedFeed[this.boardType] = currentCachedFeed.slice(0, fixedLen);
            this.$_caching.saveCachedFeeds(cachedFeed);
        }
    }

    refreshViewPort = (numItems, setTopIndex, pageNum = 0) => {
        let index;
        if (!this.$_cache.getPassword()) {
            return;
        }
        if (setTopIndex) {
            index = this.itemTopIndex;
            this.itemTopIndex = undefined;
        }
        this.fixCachedDoc();
        this.fetchActivePosts(0, 10).then((_data: any) => {
            this.initVPLoadingV2(numItems); // initialize view port loading
            this.$timeout(() => {
                this.boardData.fetchPage(pageNum).then(() => {
                    this.$timeout(() => {
                        angular.element(window).triggerHandler('resize');
                    }, 50);
                    if (setTopIndex) {
                        this.$timeout(() => {
                            this.itemTopIndex = index;
                        }, 500);
                    }
                });
            }, 0);
        })
    }

    reloadPosts(): void {
        this.$state.reload();
    }

    loadComments(): void {
        if (Array.isArray(this.documentList) && this.documentList.length > 0) {
            this.allPosts = this.documentList;
        }
        this.refreshViewPort(0, false);
    }
    newPost = (id: number[]) => {
        this.refreshViewPort(0, false);
    }

    postUploaded(id: number): void {
        let posts = this.$_feed.getCachedFeedIds("documents").filter(d => d.id == id);
        for (let item of posts) {
            item.failed = false;
            item.uploading = false;
            item.hasNotificationUpdate = true;
        }
        this.$_feed.addOrUpdateCachedFeedIds(posts, "documents", true);
        this.$_feed.addOrUpdateCachedFeedIds(posts, "posts", true).then(() => {
            if (this.boardType === 'posts' && this.allPosts.filter(p => p.id === id).length === 0) {
                this.displayNewPostButton = true;
            }
        });
    }

    postFailed(id: number): void {
        let posts = this.allPosts.filter(d => d.id == id);
        for (let item of posts) {
            item.failed = true;
            item.uploading = true;
        }
    }

    updateDocumentMetadata(id: number, data: any, updateMetadata: boolean): void {
        const updateDocData = (docs) => {
            const filteredPost = docs.find(p => p.id == id);
            if (!!filteredPost) {
                this.$_document.updateDocumentData(filteredPost, data, updateMetadata);
            }
        }
        updateDocData(this.allPosts);
        const cachedFeeds = this.$_caching.getCachedFeeds();
        updateDocData(cachedFeeds[this.boardType]);
        this.$_caching.saveCachedFeeds(cachedFeeds);
    }

    updatePostSubject(id, action) {
        this.$_document.updateDocState(this.allPosts, id, action, null);
        this.$_document.updateDocState(this.$_caching.getCachedFeeds()[this.boardType], id, action, this.boardType);
        this.subject = this.$_cache.getCurrentSubject();
    }
    updatePostUsers(subjectId, user) {
        this.$_document.updateDocumentUsers(subjectId, user, this.allPosts);
        const cachedFeeds = this.$_caching.getCachedFeeds();
        this.$_document.updateDocumentUsers(subjectId, user, cachedFeeds[this.boardType]);
        this.$_caching.saveCachedFeeds(cachedFeeds);
    }

}

function postBoard(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/carefeedBoard/components/postBoard/postBoard.directive.html',
        replace: true,
        controller: EcvPostBoard,
        controllerAs: 'postBoardVm',
        bindToController: {
            'refreshViewCallback': '=ecvUpdateCallback',
            'boardType': '@ecvBoardType',
            'boardName': '@?ecvBoardName',
            'showComments': '=?ecvShowComments',
            'defaultLimit': '@?ecvDefaultLimit',
            'displayAs': '@ecvDisplayPostAs',
            'onLoadCallback': '=ecvOnLoadCallback',
            'documentList': '=?ecvDocumentList',
            'singleton': '=?ecvSingleton',
            'signAssignor': '=?',
            'itemTopIndex': '=',
            'allPosts': '=?ecvAllPosts',
            'loading': '=',
            'displayNewPostButton': '=',
            'cmenuPlacement': '=?'
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPostBoard): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.carefeedBoard').directive('ecvPostBoard', postBoard);
